import React, { useState } from 'react';
import './App.css';
import Main from './Main';
import { BrowserRouter } from 'react-router-dom';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import { useKeycloakInstance } from './hooks/useKeycloakInstance';
import { AuthClientTokens } from '@react-keycloak/core';
import { AxiosInstanceProvider } from './contexts/AxiosInstanceProvider';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import { Provider } from 'react-redux';
import { persistor, store } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import ContentLoading from './components/ContentLoading';


function App () {
  const keycloakInstance: Keycloak | null = useKeycloakInstance();
  const [kcToken, setKcToken] = useState<string>('');

  const kcInitOptions: KeycloakInitOptions = {
    onLoad: 'login-required',
    pkceMethod: 'S256',
    enableLogging: true,
    checkLoginIframe: false
  };

  const onTokens = (tokens: AuthClientTokens) => {
    setKcToken(tokens.token ?? '');
  };

  if (!keycloakInstance) {
    return (
      <ContentLoading/>
    );
  }
  
  return (
    <ReactKeycloakProvider authClient={ keycloakInstance }
      initOptions={ kcInitOptions }
      onTokens={ onTokens }>
      { /* ReactKeycloakProvider automatically invokes keycloak.init() */ }
      { /* <React.StrictMode> needs to be removed for authentification */ }
      <Provider store={ store }>
        <PersistGate loading={ null }
          persistor={ persistor }>
          { /* We can replace null with a react instance like <Loading/> */ }
          <BrowserRouter basename={ `${ process.env.PUBLIC_URL }` }>
            <AxiosInstanceProvider token={ kcToken }>
              <Main/>
            </AxiosInstanceProvider>
          </BrowserRouter>
        </PersistGate>
      </Provider>
    </ReactKeycloakProvider>
  );
}

export default App;
